import { ClipLoader, SyncLoader } from "react-spinners";
import "./loader.scss";
import classNames from "classnames";

export const LoadingAnimation = (props: any) => {
  let classes = classNames(
    "d-flex w-100 justify-content-center align-items-center loading-animation",
    props.className
  );
  return (
    <div className={classes}>
      <SyncLoader size={15} color={"#2775ab"} />
      {/* <div className="px-5 font-weight-bold mt-3 text-center">{this.props.text}</div> */}
    </div>
  );
};

export const ButtonLoadingAnimation = () => {
  return (
    <div>
      <SyncLoader size={10} color={"#FFF"} />
      {/* <div className="px-5 font-weight-bold mt-3 text-center">{this.props.text}</div> */}
    </div>
  );
};

export const LayoverLoadingAnimation = () => {
  return (
    <div className="layover-loader">
      <div className="d-flex h-100 align-items-center justify-content-center">
        <SyncLoader size={15} color={"#2775ab"} />
      </div>

      {/* <div className="px-5 font-weight-bold mt-3 text-center">{this.props.text}</div> */}
    </div>
  );
};

export const LayoverLoadingAnimationComponent = () => {
  return (
    <div className="layover-loader">
      <div className="d-flex h-100 justify-content-center custom-position position-absolute ">
        <SyncLoader size={15} color={"#2775ab"} />
      </div>

      {/* <div className="px-5 font-weight-bold mt-3 text-center">{this.props.text}</div> */}
    </div>
  );
};

export const ClipLoaderAnimation = () => {
  return (
    <div className="">
      <ClipLoader size={15} color={"#2775ab"} />
    </div>
  );
};


export const LazyLoadingAnimation = (props: any) => {
  let classes = classNames(
    "d-flex w-100 justify-content-center align-items-center",
    props.className
  );
  return (
    <div className={classes}>
      <SyncLoader size={15} color={"#2775ab"} />
      {/* <div className="px-5 font-weight-bold mt-3 text-center">{this.props.text}</div> */}
    </div>
  );
};